import { render, staticRenderFns } from "./main-banner.vue?vue&type=template&id=36a9a6eb&scoped=true&"
import script from "./main-banner.vue?vue&type=script&lang=ts&"
export * from "./main-banner.vue?vue&type=script&lang=ts&"
import style0 from "./main-banner.vue?vue&type=style&index=0&id=36a9a6eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a9a6eb",
  null
  
)

export default component.exports